import defaultIcons from './default';
import filterIcons from './filter';

export default {
    default: defaultIcons,
    filter: filterIcons
};
